import React, { useContext } from "react";
// import MemberAccount from "./Member-Signup/MemberAccount";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import "./Signup.css";
// import DynamicStepper from "../../Common/Stepper/Stepper";
// import MemberRole from "./Member-Signup/MemberRole";
// import MemberPurpose from "./Member-Signup/MemberPurpose";
// import BorderLinearProgressBar from "../../Common/Border-linear-process/BorderLinearProgress";
import SignupCompletion from "./SignupCompletion";
import { DynamicContext } from "../../Context/DynamicContext";
import MemberMain from "./Member-Signup/MemberMain";
function MemberSignupPage() {
  const { isSignupCompleted, isDarkMode } = useContext(DynamicContext);
  // const steps = [
  //   { title: <span style={{ fontWeight: 600 }}>Account</span> },
  //   { title: <span style={{ fontWeight: 600 }}>Role</span> },
  //   { title: <span style={{ fontWeight: 600 }}>Purpose</span> },
  // ];

  // const [activeStep, setActiveStep] = useState(0);
  // const [completedSteps, setCompletedSteps] = useState([]);
  // const progress = (completedSteps.length / steps.length) * 100;
  // const progressColor = "#4caf50";

  // const handleNext = (isValid) => {
  //   if (isValid) {
  //     if (!completedSteps.includes(activeStep)) {
  //       setCompletedSteps([...completedSteps, activeStep]);
  //     }
  //     setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
  //   }
  // };

  // const handleBack = () => {
  //   if (completedSteps.includes(activeStep)) {
  //     setCompletedSteps(completedSteps.filter((step) => step !== activeStep));
  //   }
  //   const stepsToKeep = completedSteps.filter((step) => step < activeStep);
  //   setCompletedSteps(stepsToKeep);

  //   setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
  // };

  // const getStepContent = (step) => {
  //   switch (step) {
  //     case 0:
  //       return <MemberAccount onContinue={handleNext} onBack={handleBack} />;
  //     case 1:
  //       return <MemberRole onContinue={handleNext} onBack={handleBack} />;
  //     case 2:
  //       return <MemberPurpose onContinue={handleNext} onBack={handleBack} />;
  //     default:
  //       return "Unknown step";
  //   }
  // };

  return (
    <>
      {isSignupCompleted ? (
        <SignupCompletion />
      ) : (
        <div
          className={`signup-outer-container ${
            isDarkMode ? "no-bg-image" : ""
          }`}
        >
          <div className="signup-icon-text">
            <img
              alt="VylabsIcon"
              src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
              className="vy-labs-logo"
            />
            <div className="signup-welcome-container">
              <h2 className="signup-main-header">
                Welcome to the future of recruitment
              </h2>
              <span className="signup-side-text">
                Smarter hiring starts here. Find, evaluate, and hire talent faster.
              </span>

              {/* <DynamicStepper
                steps={steps}
                activeStep={activeStep}
                completedSteps={completedSteps}
              />
              <div className="signup-progress-bar">
                <BorderLinearProgressBar
                  value={progress}
                  progressColor={progressColor}
                  sx={{ width: "100%", height: "8px" }}
                />
              </div>
              <div className="step-counter">
                Step {activeStep + 1} of {steps.length}
              </div> */}
            </div>
          </div>
          <div className="stepper-render-ui">
            <MemberMain />
          </div>
        </div>
      )}
    </>
  );
}

export default MemberSignupPage;
